import 'protons';
import './_hero-slider.scss';
import './_hero-slider.twig';

// import Swiper JS
import SwiperCore, { Autoplay, Navigation, Pagination } from 'swiper/core';

SwiperCore.use([Autoplay, Navigation, Pagination]);

export const name = 'hero-slider';

export const defaults = {};

export function disable() {}

export function enable(context) {
  // Make sure we don't call methods on something weird that might habe been
  // returned from Drupal.
  if (context instanceof Element || context instanceof Document) {
    const heroSliders = Array.prototype.slice.call(
      context.querySelectorAll('.hero-slider')
    );

    heroSliders.forEach((heroSlider) => {
      const slider = heroSlider.querySelector('.swiper-container');
      const pagination = heroSlider.querySelector('.hero-slider__pagination');
      const next = heroSlider.querySelector('.hero-slider__next');
      const prev = heroSlider.querySelector('.hero-slider__prev');

      // eslint-disable-next-line no-new
      new SwiperCore(slider, {
        autoHeight: true,
        autoplay: {
          delay: 8000,
          disableOnInteraction: true,
        },
        speed: 1000,
        loop: true,
        pauseOnMouseEnter: true,
        pagination: {
          el: pagination,
          clickable: true,
        },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
      });
    });
  }
}

export default enable;
